<template>
  <div class="modal fade big_modal" id="modal-email-change">
    <div class="modal-header">
      <h3 class="title">
        <span class="fa" style="width: 5.6em">
          <span class="fa-light fa-envelope fa-2x" style="margin-top: -15px"></span>
          <span class="fa-light fa-arrow-right fa" style="margin: 0 10px; margin-top: -0.2em"></span>
          <span class="fa-light fa-envelope fa"></span>
        </span>
        <span>{{ i18nJS.user_modal_email_change.title }}</span>
      </h3>
      <button class="close" aria-hidden="true" data-dismiss="modal" type="button">
        <i class="fa-light fa-xmark"></i>
      </button>
    </div>

    <form class="form-inline form-area-js form-item-be form-search" disabled>
      <div class="modal-body">
        <div class="box_msg alert alert-info">
          <strong>
            <div class="box_msg--msg">
              <p v-html="i18nJS.user_modal_email_change.email_info_html"></p>
            </div>
          </strong>
        </div>

        <div class="well">
          <div class="row-fluid">
            <label class="span2">{{ i18nJS.fullname }}</label>
            <div class="span2">{{ fullname }}</div>
            <div class="span2">({{ username }})</div>
            <label class="span2">{{ i18nJS.user_modal_email_change.new_email }}</label>
            <div class="span4 obbligatorio">
              <input type="email" required="true" v-model="newEmail" ref="new-email-input" />
            </div>
          </div>
          <div class="row-fluid">
            <label class="span2">{{ i18nJS.user_modal_email_change.current_email }}</label>
            <div class="span4">{{ email }}</div>
            <label class="span2">{{ i18nJS.user_modal_email_change.new_email_confirmation }}</label>
            <div class="span4 obbligatorio">
              <input type="email" required="true" v-model="newEmailConfirmation" />
              <span class="fa-light fa-circle-xmark red" v-if="(bothEmailFieldsCompiled && errorOnEmail) || sameEmailAsCurrentOne" />
              <div class="input--error" v-if="sameEmailAsCurrentOne">
                {{ i18nJS.user_modal_email_change.same_as_previous }}
              </div>
              <span class="fa-light fa-check green" v-if="bothEmailFieldsCompiled && !errorOnEmail" />
            </div>
          </div>
        </div>

        <div class="box_msg alert">
          <strong>
            <span class="box_msg--msg">
              <p v-html="i18nJS.user_modal_email_change.gdpr_consent_html"></p>
            </span>
          </strong>
        </div>

        <div class="confirmation--section">
          <input type="checkbox" v-model="acceptedConditions" />
          <label>* {{ i18nJS.user_modal_email_change.confirmation_formula }}</label>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-success" @click="submit" :disabled="cannotSubmit">{{ i18nJS.command.forward_request }}</button>
        <a class="btn secondary" data-dismiss="modal" href="#">{{ i18nJS.command.close }}</a>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'changeUserEmailModal',
  props: ['email', 'action', 'fullname', 'username'],
  data: () => ({
    acceptedConditions: false,
    newEmail: '',
    newEmailConfirmation: '',
  }),
  computed: {
    bothEmailFieldsCompiled() {
      return this.newEmail != '' && this.newEmailConfirmation != '';
    },
    cannotSubmit() {
      return !this.bothEmailFieldsCompiled || this.errorOnEmail || !this.acceptedConditions;
    },
    i18nJS() {
      return window.i18nJS;
    },
    sameEmailAsCurrentOne() {
      return this.newEmail == this.email;
    },
    errorOnEmail() {
      return this.newEmail != this.newEmailConfirmation || this.sameEmailAsCurrentOne || !this.validEmail();
    },
  },
  mounted() {
    $('#modal-email-change').modal('show');
  },
  methods: {
    validEmail() {
      return this.$refs['new-email-input'] == undefined || this.$refs['new-email-input'].checkValidity();
    },
    submit() {
      if (this.validEmail()) {
        Loader.show();
        axios({
          method: 'post',
          url: this.action,
          data: {
            format: 'json',
            accepted_conditions: this.acceptedConditions,
            user: {
              email: this.newEmail,
            },
          },
          headers: {
            'Content-type': 'application/json',
            'X-CSRF-Token': $.rails.csrfToken(),
          },
        })
          .then((response) => {
            if (response.status == 204 || response.status == 200) {
              window.location.reload();
            }
          })
          .catch((error) => {
            Utils.appendToFlash('error', 'Operatore inesistente');
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  background: #ffffff;
  box-shadow: 2px 2px 2px 1px;
  overflow-x: auto;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  padding: 15px;
  border-bottom: 1px solid #eeeeee;
  color: #ef7b12;
  justify-content: space-between;
}

.confirmation--section {
  display: flex;
  align-items: center;
  flex-flow: row-reverse;

  & > label {
    font-weight: bold;
    width: 85%;
    text-align: right;
    margin: 1em;
  }

  & > input {
    margin: 1em;
    height: 1em;
    width: 1em;
  }
}

.modal-footer {
  display: flex;
  padding: 15px;
  border-top: 1px solid #eeeeee;
}

.modal-body {
  overflow-y: auto;
  position: relative;
  padding: 20px 10px;
}

.modal-footer {
  flex-flow: row-reverse;
}

.btn-close {
  border: none;
  font-size: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #ef7b12;
  background: transparent;
}

.btn-green {
  color: white;
  background: #ef7b12;
  border: 1px solid #ef7b12;
  border-radius: 2px;
}
</style>
